import React, { useState, useEffect, use } from "react";
import SearchInput from "../../components/SearchInput";
import FilterSearchResults from "../../components/FilterSearchResults";
import ResourceLibraryFilter from "./ResourceLibraryFilter";
import RenderSearchResults from "../../components/RenderSearchResults";
import ResearchListing from "./ResourceListing";
import { useDispatch, useSelector } from "react-redux";
import { getSearchResults, resetSearchPage, getProducts, getSuggestion, resetSuggestion,resetProductList, getRealSuggestion } from "../../containers/searchLandingSlice";
import {resetPage,getResourceLibrary} from '../../containers/resourceLibrarySice/resourceLibrarySlice'
import { getFacetResults, resetFacet } from "../../containers/searchLandingSlice";
import { useSearchParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentLocal } from '../../utils'

export const ResourceLibrary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const resourceAPIResponse = useSelector((state) => state?.resourceLibrary?.resource);
  const totalResource = useSelector((state) => state?.resourceLibrary?.total);
  const facetResults = useSelector((state) => state?.resourceLibrary?.filters);
  const productList = useSelector((state) => state?.searchLanding?.productCarousel?.products?.docs);
  const suggestion = useSelector((state) => state?.searchLanding?.suggestion);
  const suggestionLoader = useSelector((state) => state?.searchLanding?.suggestion?.isLoading);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchResults, setSearchResults] = useState([]);

  let ignore = false;
  const isMobile = window.innerWidth < 1024;

  useEffect(() => {
    if (!ignore) {
      dispatch(resetPage());
      const q = searchParams.get('q') ? searchParams.get('q') : '*';
      const page = searchParams.get('p') ? searchParams.get('p') : 1;
      setCurrentPage(page);
      const resourceLibraryQuery = getResourceLibraryQuery(q);
	  dispatch(getResourceLibrary(resourceLibraryQuery))
    //   dispatch(getProducts(productListQuery));
      const searchInput = searchParams.get('q') ? searchParams.get('q') : '';
    //   if (searchInput.length > 1) {
    //     const { finalSearchListQuery } = getSearchListingQuery(searchInput);
    //     const { facetSearchQuery } = getFacetQuery({ query: searchInput, docType: null });
    //     dispatch(getSearchResults(finalSearchListQuery));
    //     setSearchResults(resourceAPIResponse?.docs);
    //     dispatch(getFacetResults(facetSearchQuery));
    //   }
      return () => {
        ignore = true;
      };
    }

  }, []);

  useEffect(() => {
    if (!resourceAPIResponse) {
      setSearchResults([]);
    }
    else {
      setSearchResults(resourceAPIResponse);
    }

  }, [resourceAPIResponse]);


  const getResourceLibraryQuery = (q,page=1) =>{
	let paginationCount=9
	const documentType="&documentType=Documents&fq=documentType:Documents"
	const locale='&locale='+getCurrentLocal().toLowerCase()
	const groupby="&groupBy=subDocumentType,filterSubDocumentType&sort=documentTypeDate"
	const pagination =  "&from="+ ((page - 1) * paginationCount) + "&rows="+paginationCount
	return "?q="+q+documentType+locale+groupby+pagination
  }




  const getSearchListingQuery = (searchQuery) => {
    const paginationCount = 5;
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,title,description,url,contentType,filterSubDocumentType&groupBy=grpDocumentType&from=" + ((currentPage - 1) * paginationCount) + "&rows=" + paginationCount;
    let finalSearchListQuery = "?q=" + searchQuery + variableParams;
    return { finalSearchListQuery };
  }


  const getFilteredData = (selectedDocs,query)=>{
	if(query?.length>0){
		setSearchParams({ q: query });
	}
    dispatch(resetPage());
	let resourceLibraryQuery = getResourceLibraryQuery(query.length>2 ? query :'*');
	if(selectedDocs.length>0){
		let fq='&fq='
		selectedDocs.map((item)=>{
			fq=fq+item.mainKey+':'+item.docType+','
		})
		resourceLibraryQuery=resourceLibraryQuery+fq
	}
	dispatch(getResourceLibrary(resourceLibraryQuery))
  }


  const getFacetQuery = (queryObj) => {
    let facetSearchQueryParams = "";
    const variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,title&groupBy=grpDocumentType&groupLimit=10&size=5";
    if (queryObj.query) {
      facetSearchQueryParams = "?q=" + queryObj.query;
    }
    if (queryObj.docType && queryObj.docType.length > 0) {
      facetSearchQueryParams = facetSearchQueryParams + "&fq=documentType:" + queryObj.docType;
    }
    const facetSearchQuery = facetSearchQueryParams + variableParams;
    return { facetSearchQuery };

  }
  const handleSearchQueryChange = (newSearchQuery) => {
    dispatch(resetPage());
    if (newSearchQuery.length > 0) {
      setSearchParams({ q: newSearchQuery });
      const  finalSearchListQuery  = getResourceLibraryQuery(newSearchQuery,currentPage);
    //   const { facetSearchQuery } = getFacetQuery({ query: newSearchQuery, docType: null });
    //   dispatch(getSearchResults(finalSearchListQuery));
      dispatch(getResourceLibrary(finalSearchListQuery));
    //   dispatch(getFacetResults(facetSearchQuery));

    }
    else {
      if (!newSearchQuery || newSearchQuery.length === 0) {
        dispatch(resetPage());
        // Reset the facet filters 
        // dispatch(resetFacet());
        setSearchResults([]);
        dispatch(getResourceLibrary(getResourceLibraryQuery(newSearchQuery,currentPage)));
        // Clear the search parameters
        setSearchParams();
      }
    }
  };

  const filterSelectedOptions = (newFilter) => {
    let facetTypeParams = "";
    const currentSearchInput = searchParams.get('q');
    const commaSeparatedFilter = [...newFilter].join(', ');
    if (commaSeparatedFilter.length > 0) {
      if (commaSeparatedFilter === 'All Results') {
        facetTypeParams = "";
      }
    } else {
      facetTypeParams = "&?fq=documentType:" + commaSeparatedFilter;
    }
    const { finalSearchListQuery } = getSearchListingQuery(currentSearchInput + facetTypeParams);
    dispatch(getSearchResults(finalSearchListQuery));

  };

  const sanitizeInput = (input) => {
    const cleanInput = input.replace(/<\/?[^>]+(>|$)/g, "").trim();
    const words = cleanInput.split(" ");
    const sanitizedWords = words.map((word) =>
      word.includes("-") ? `"${word}"` : word
    );
    return sanitizedWords.join(" ");
  };

  const getSuggestionData = async (searchText) => {
    let payload=sanitizeInput(searchText)
    let specialCharacters = /[+\-&&||!(){}[\]^"~*?:/]/g;
    let sanitizedPayload = payload.replace(specialCharacters, "\\$&");
    let q = '?q=' + sanitizedPayload
    let variableParams = "&locale=" + getCurrentLocal().toLowerCase() + "&fl=id,url,productCategoryPagePath_s,productCategoryTitle_s,breadcrumbSubCategoryPagePath_s,breadcrumbSubCategoryTitle_s,primaryImage,title&groupBy=grpDocumentType&groupLimit=5&documentType=Products,Support%20Products,Software%20Downloads,Knowledge%20Base,Community,documents&channel=web";
    dispatch(getSuggestion(q + variableParams))
    variableParams="&locale=" + getCurrentLocal().toLowerCase() + "&rows=5&documentType=products&fq=filterBy:products&channel=web";
    dispatch(getRealSuggestion(q+variableParams))

  }

  const clearSuggestion = () => {
    dispatch(resetSuggestion())
  }

  const handlePageChange = async (page) => {
	const q = searchParams.get('q') ? searchParams.get('q') : '*';
	await setSearchParams({ q: q, p: page });
    await setCurrentPage(page);
	const  finalSearchListQuery  = getResourceLibraryQuery(q,page);
      dispatch(getResourceLibrary(finalSearchListQuery));
    // dispatch(getSearchResults(finalSearchListQuery));
  };

  return (
    <section className="sd-relative">
      <div className="sd-container">
        <div className="sd-grid lg:sd-grid-cols-16 sd-grid-cols-8 lg:sd-gap-4">
          <div className="lg:sd-col-span-4 sd-col-span-8 lg:sd-min-h-screen-minus-48 sd-gap-4 sd-top-12 lg:sd-top-auto lg:sd-self-end lg:sd-sticky lg:sd-bottom-[0] sd-border-r lg:sd--ml-4">
            <div className="lg:sd-py-[35px] sd-pt-[2rem] sd-pb-[1rem]  lg:sd-pl-4 sd-sdList lg:sd-border-b lg:sd-col-span-8 sd-col-span-4">
              {!isMobile ? (
                <h2 className="sd-uppercase sd-titleText  sd-font-nb sd-text-[13px]">{t('backToHome')}</h2>
              ) : (
                <a href="#" className="sd-uppercase sd-titleText sd-font-nb sd-text-[13px]">{'home / Search'}
                </a>
              )}
            </div>
            {
              <ResourceLibraryFilter searchResults={facetResults} onFilterChange={filterSelectedOptions} getFilteredData={getFilteredData}/>
            }
          </div>
          <div className="sd-gap-4 sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 lg:sd-pt-20 lg:sd-pt-[35px]">
            {/* <SearchInput onSearchQueryChange={handleSearchQueryChange}  /> */}
			<ResearchListing searchResults={searchResults} onPageChange={handlePageChange} listingHeader={''} totalResource={totalResource}/>
            {/* {<RenderSearchResults searchResults={searchResults} onPageChange={handlePageChange} productList={productList}/>} */}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourceLibrary;

